// extracted by mini-css-extract-plugin
export default {"canvasList":"CanvasList_canvasList__X7uaC","headerActions":"CanvasList_headerActions__enqNZ"};